/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Phone_Is_Screen_Sharing_AllowedInputs */

const en_forms_teams_settings_phone_is_screen_sharing_allowed = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_Screen_Sharing_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharing Allowed`)
};

const de_forms_teams_settings_phone_is_screen_sharing_allowed = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_Screen_Sharing_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildschirmfreigabe erlaubt`)
};

/**
* | output |
* | --- |
* | "Sharing Allowed" |
*
* @param {Forms_Teams_Settings_Phone_Is_Screen_Sharing_AllowedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_phone_is_screen_sharing_allowed = /** @type {((inputs?: Forms_Teams_Settings_Phone_Is_Screen_Sharing_AllowedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Phone_Is_Screen_Sharing_AllowedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_phone_is_screen_sharing_allowed(inputs)
	return de_forms_teams_settings_phone_is_screen_sharing_allowed(inputs)
});